import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    fields: {
      issuerEmail: 'Display my email address (optional)',
      lateFeeHint: 'Legally, the minimum late penalty should be {min}%.',
      lateFeeLink: 'Learn more',
      lateFeePercentage: 'Late payment penalties in %',
      lateMaxDays: 'Payment Period',
      legalMentions: 'Additional legal notices (optional)',
    },
    sectionTitle: 'Options',
  },
  fr: {
    fields: {
      issuerEmail: 'Afficher mon adresse email (optionnelle)',
      lateFeeHint:
        'Légalement, la pénalité de retard minimum doit être de {min}\xA0%.',
      lateFeeLink: 'En savoir plus',
      lateFeePercentage: 'Pénalité de retard en %',
      lateMaxDays: 'Délai de paiement',
      legalMentions: 'Mentions légales personnalisées (optionnelle)',
    },
    sectionTitle: 'Options',
  },
} as const);

export default locales;
